export function ParallaxEffect(elem) {
  const fadeTops = document.querySelectorAll(`#${elem.id} .parallax-fade-top`);
  var scrollPos;
  if (detectMob()) {
    console.log("sorry no animations for you");
  } else {
    window.addEventListener("scroll", () => {
      scrollPos = document.scrollingElement.scrollTop - elem.offsetTop;

      for (let fadeTop of fadeTops) {
        fadeTop.style.top = scrollPos / 2 + "px";
        fadeTop.style.opacity = 1 - scrollPos / 300;
      }
    });
  }
}

export function scrollPosition(elem) {
  if (detectMob()) {
    return null;
  } else {
    if (elem) {
      return document.scrollingElement.scrollTop - elem.offsetTop;
    }
    return document.scrollingElement.scrollTop;
  }
}

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  if (window.innerWidth < 750) {
    return true;
  }

  return toMatch.some(toMatchItem => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
